import { jsx as n, jsxs as m } from "react/jsx-runtime";
import { forwardRef as b, useRef as p, useState as h } from "react";
import { B as C } from "../checkbox/BaseCheckbox-BGkrjof6.mjs";
import "../icons/HeartToggle-Bwgo4FxH.mjs";
import { e as N, f as x } from "../icons/Icons-CVv5JxOX.mjs";
const B = b(
  ({ defaultChecked: a, toggledContentId: i, lightBackground: r, children: c, onChange: o, id: g, className: d = "", ...u }, _) => {
    const f = p(null), [t, l] = h(!!a), e = _ || f;
    return /* @__PURE__ */ n(
      C,
      {
        id: g,
        ref: e,
        onChange: (k) => {
          var s;
          typeof o == "function" && o(k), l(typeof e != "function" ? !!((s = e.current) != null && s.checked) : !t);
        },
        checked: t,
        "aria-controls": i,
        dataTestId: "toggle-link-button__label",
        containerClassName: "rds-toggle-link-button",
        inputClassName: "rds-toggle-link-button__input",
        labelClassName: `rds-toggle-link-button__label ${r ? "rds-light" : ""} ${d}`,
        ...u,
        children: /* @__PURE__ */ m("span", { className: "rds-toggle-link-button__label__content rds-link", "data-testid": "toggle-link-button__label__text", children: [
          c,
          !t && /* @__PURE__ */ n(N, { className: "rds-toggle-link-button__icon" }),
          t && /* @__PURE__ */ n(x, { className: "rds-toggle-link-button__icon" })
        ] })
      }
    );
  }
);
B.displayName = "ToggleLinkButton";
export {
  B as T
};
